<template>
<v-card>
  <v-card-actions>

    <v-spacer></v-spacer>

    <v-btn fab dark x-small color="primary" slot="activator" @click.native="openModal(1)" title="Nueva Patente" v-tippy>
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon class="white--text">edit</v-icon>&nbsp;
            <span class="subheading">
              <strong v-if="!editando">Nuevos Sellos Digitales de Patente</strong>
              <strong v-if="editando">Actualizar Sellos Digitales de Patente</strong>
            </span>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modal = false" class="close_modal">
            <v-icon class="white--text">cancel</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md text-xs-center>
              <v-form ref="form" lazy-validation :action="URL" method="post">
                <v-card-text>
                  <v-container grid-list-md text-xs-center @keyup.enter="send()">
                    <v-layout v-if="!editando" row wrap>
                      <v-flex s6 m6 l6>
                        <v-text-field name="rfc_agente" @input="quitaEspacios" @change="quitaEspacios" @onPaste="quitaEspacios" label="RFC Agente Aduanal" type="text" v-model="model.rfc_agente" :rules="[rules.required]" maxlength="20">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="!editando" row wrap>
                      <v-flex s6 m6 l6>
                        <v-autocomplete clearable :hide-no-data="true" :items="patentesArr" v-model="model.patente" label="Patente"></v-autocomplete>
                        <!-- <v-text-field name="Patente" label="Patente" type="text" v-model="model.patente">
                        </v-text-field> -->
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="!editando">
                      <v-flex s6 m6 l6>
                        <v-text-field name="curp" @input="quitaEspacios" @change="quitaEspacios" @onPaste="quitaEspacios" label="CURP" type="text" v-model="model.curp" :rules="[rules.required]" maxlength="20">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s6 m6 l6>
                        <v-text-field name="clave" @input="quitaEspacios" @change="quitaEspacios" @onPaste="quitaEspacios" label="Clave Web Service" type="text" v-model="model.clave_ws" :rules="[rules.required, rules.sized]" maxlength="100">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s6 m6 l6>
                        <v-text-field name="nombre" label="Contraseña del Certificado" type="text" v-model="model.password" maxlength="50"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s6 m6 l6>
                        <span class="v-label theme--light font-weight-bold left">Certificado</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s6 m6 l6>
                        <file-pond allowPaste=false name="certificado" ref="certificado" requiered class-name="my-pond" labelIdle="<span class='filepond--label-action'> Arrastre o seleccione su archivo .CER   AquÍ </span>"
                          labelInvalidField="Archivo no valido" labelFileWaitingForSize="Calculando el tamaño" labelFileSizeNotAvailable="Tamaño no valido" labelFileLoading="Cargando.." labelFileLoadError="Error al cargar"
                          labelFileProcessing="Subiendo" labelFileProcessingComplete="Carga completa" labelFileProcessingAborted="Carga cancelada" labelFileProcessingError="Error durante la carga" labelFileProcessingRevertError="Error"
                          labelFileRemoveError="Error al eliminar" labelTapToCancel="Cancelar" labelTapToRetry="Reintentar" labelTapToUndo="Deshacer" labelButtonRemoveItem="Eliminar" labelButtonAbortItemLoad="Abortar"
                          labelButtonRetryItemLoad="Reintentar" labelButtonAbortItemProcessing="Cancelar" labelButtonUndoItemProcessing="Deshacer" labelButtonRetryItemProcessing="Reintentar" labelButtonProcessItem="Subir" accepted-file-types=".cer"
                          v-bind:files="file_cer" v-bind:server="myServerCER" allowFileTypeValidation />
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s12 m2>
                        <span class="v-label theme--light font-weight-bold left">LLave</span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex s6 m6 l6>
                        <file-pond allowPaste=false name="llave" ref="llave" class-name="my-pond" labelIdle="<span class='filepond--label-action'> Arrastre o seleccione su archivo .KEY   AquÍ </span>" labelInvalidField="Archivo no valido"
                          labelFileWaitingForSize="Calculando el tamaño" labelFileSizeNotAvailable="Tamaño no valido" labelFileLoading="Cargando.." labelFileLoadError="Error al cargar" labelFileProcessing="Subiendo"
                          labelFileProcessingComplete="Carga completa" labelFileProcessingAborted="Carga cancelada" labelFileProcessingError="Error durante la carga" labelFileProcessingRevertError="Error" labelFileRemoveError="Error al eliminar"
                          labelTapToCancel="Cancelar" labelTapToRetry="Reintentar" labelTapToUndo="Deshacer" labelButtonRemoveItem="Eliminar" labelButtonAbortItemLoad="Abortar" labelButtonRetryItemLoad="Reintentar"
                          labelButtonAbortItemProcessing="Cancelar" labelButtonUndoItemProcessing="Deshacer" labelButtonRetryItemProcessing="Reintentar" labelButtonProcessItem="Subir" accepted-file-types=".key" v-bind:files="file_key"
                          v-bind:server="myServerKEY" allowFileTypeValidation />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="modal = false">
            <v-icon>cancel</v-icon>Cancelar
          </v-btn>
          <v-btn color="success" :loading="loading" @click.native="send()">
            <v-icon>done</v-icon>Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card-actions>

  <v-card-text>
    <div id="datagrid">

      <v-client-table ref="vuetable" :data="sellos.items" :columns="columns" :options="options" class="elevation-2 pa-2">
        <template slot="noResults">
          <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
        </template>

        <template slot="clave_ws" slot-scope="props">
          <div>
            {{props.row.clave_ws != undefined ? props.row.clave_ws.substring(0,20) + "*************":"Sin Clave WS" }}
          </div>

        </template>
        <template slot="estatus" slot-scope="props">
          <div style="text-align:center">
            <v-chip v-if="props.row.file_cer == null || props.row.file_cer == ''" outlined olor="blue">
              <v-icon color="blue" left>label</v-icon>Sin Sellos
            </v-chip>
            <v-chip v-if="props.row.estatus == 2" outlined color="red">
              <v-icon color="red" left>cancel</v-icon>Sellos Inválidos
            </v-chip>
            <v-chip v-if="props.row.file_cer != null && props.row.file_cer != ''" outlined color="green">
              <v-icon color="green" left>check_circle</v-icon>Válidos
            </v-chip>
          </div>
        </template>

        <template slot="estatus_clave" slot-scope="props">
          <div style="text-align:center">
            <v-chip v-if="props.row.estatus == 0" outlined olor="blue">
              <v-icon color="blue" left>label</v-icon>Sin Probar
            </v-chip>
            <v-chip v-if="props.row.estatus == 1" outlined color="green">
              <v-icon color="green" left>check_circle</v-icon>Válida
            </v-chip>
            <v-chip v-if="props.row.estatus == 3" outlined color="red">
              <v-icon color="red" left>cancel</v-icon>Clave WS Invalida
            </v-chip>
          </div>
        </template>

        <template slot="actions" slot-scope="props">
          <v-btn x-small fab color="gray" title="Logs" @click="open_log(props.row.patente)">
            <v-icon dark>history</v-icon>
          </v-btn>
          <v-btn x-small fab dark color="success" @click.native="editar(props.row)" title="Actualizar" v-tippy>
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn v-if="props.row.file_cer!=null" x-small fab dark color="blue" @click.native="
                          download(
                            rfc + '-' + props.row.rfc_agente + '.cer',
                            props.row.file_cer
                          )
                        " title="Descargar CER" v-tippy>
            <v-icon>attach_file</v-icon>
          </v-btn>
          <v-btn v-if="props.row.file_cer!=null && $local_storage.get('tipo_usuario') == 'Super Usuario'" x-small fab dark color="secondary" @click.native="
                          download(
                            rfc + '-' + props.row.rfc_agente + '.key',
                            props.row.file_cer
                          )
                        " title="Descargar KEY" v-tippy>
            <v-icon>mdi-file-key</v-icon>
          </v-btn>
          <v-btn x-small fab color="red" title="Eliminar" @click="eliminar(props.row.id)">
            <v-icon dark>delete</v-icon>
          </v-btn>
        </template>
      </v-client-table>
    </div>
  </v-card-text>
  <v-dialog v-model="modal_log" max-width="60%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <span class="subheading">
            <strong>Log de Cambios de Sellos WS</strong>
          </span>
        </v-card>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <div id="datagrid">

          <v-client-table ref="vuetable" :data="logs" :columns="options_logs.columns" :options="options_logs" class="elevation-2 pa-2">
            <template slot="noResults">
              <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
            </template>
          </v-client-table>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-card>
</template>

<script>
// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";

// Import styles
import "filepond/dist/filepond.min.css";

import axios from "axios";

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: "app",
  created: async function() {
    this.cliente = this.$local_storage.get("id_cliente");
    this.usuario = this.$local_storage.get("id_usuario");
    this.rfc = this.$local_storage.get("rfc_grupo");
    this.URL = this.$hostname + "catalogos/certificados/";
    await this.getPatentes();
    await this.cargar();
  },
  data: function() {
    return {
      fab: false,
      patentesArr: [],
      name: "datagrid",
      editando: false,
      columns: [
        "rfc_agente",
        "patente",
        "curp",
        "clave_ws",
        "fecha_caducidad",
        "estatus",
        "estatus_clave",
        "actions"
      ],
      show_loading: true,
      options: {
        sortable: ["fecha_actualizacion"],
        filterable: [],
        orderBy: {
          column: "fecha_actualizacion",
          ascending: false
        },

        headings: {
          rfc_agente: "RFC Agente",
          patente: "Patente",
          curp: "CURP ",
          clave_ws: "Clave Web Service",
          fecha_caducidad: "Fecha de Caducidad",
          estatus: "Estatus",
          estatus_clave: "Estatus Clave WS",
          actions: "Descargas"
        }
      },
      options_logs: {
        sortable: ["fecha"],
        filterable: [],
        orderBy: {
          column: "fecha",
          ascending: false
        },

        headings: {
          fecha: "Fecha de Actualización",
          clave_ws: "Clave Web Service",
          fecha_caducidad: "Fecha de Caducidad",
          password: "Password",
        },
        columns: [
          "fecha",
          "clave_ws",
          "fecha_caducidad",
          "password",
        ],
      },
      URL: "",
      show_loading: true,
      loading: false,
      title: "",
      modal: false,
      update: false,
      rfc: "",
      search: "",
      model: {
        id_aduana: 0,
        nombre: "",
        clave: "",
        rfc_agente: "",
        patente: "",
        curp: ""
      },
      rules: {
        required: v => !!v || "Este campo es requerido",
        sized: v => v.length == 64 || "El tamaño de la clave debe de ser de 64 caracteres"
      },
      sellos: {
        selected: [],
        headers: [{
            text: "Aduana",
            value: "nombre"
          },
          {
            text: "Clave",
            value: "clave"
          },
          {
            text: "Operaciones",
            value: "operaciones",
            align: "center",
            width: "20%"
          }
        ],

        //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
        encabezadoLayout: {
          nombre: "nombre",
          clave: "clave"
        },
        //van vacíos para solo descargar layout con encabezados
        camposLayout: [{
          nombre: "[Nombre del Certificado]",
          clave: "[Clave del Certificado]"
        }],

        items: []
      },
      file_cer: [],
      file_key: [],
      cliente: null,
      usuario: null,
      file_c: null,
      file_k: null,
      URL: "#",
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Organización",
          disabled: true,
          to: ""
        },
        {
          text: "Sellos Digitales",
          disabled: true,
          to: ""
        }
      ],
      loading: false,
      modal: false,
      modal_log: false,
      logs: [],
      search: "",

      myServerCER: {
        process: (fieldName, file, metadata, load) => {
          //this.file_c = file;
          const fr = new FileReader();
          fr.readAsDataURL(file);
          fr.addEventListener('load', () => {
            this.file_c = fr.result; // archivo en base64
          });

          // simulates uploading a file
          setTimeout(() => {
            load(Date.now());
          }, 5);
        },
        load: (source, load) => {
          // simulates loading a file from the server
          fetch(source)
            .then(res => res.blob())
            .then(load);
        }
      },
      myServerKEY: {
        process: (fieldName, file, metadata, load) => {
          //this.file_k = file;
          const fr = new FileReader();
          fr.readAsDataURL(file);
          fr.addEventListener('load', () => {
            this.file_k = fr.result; // archivo en base64
          });
          // simulates uploading a file
          setTimeout(() => {
            load(Date.now());
          }, 5);
        },
        load: (source, load) => {
          // simulates loading a file from the server
          fetch(source)
            .then(res => res.blob())
            .then(load);
        }
      }
    };
  },
  methods: {
    getPatentes: function() {

      //PATENTES
      axios.post(this.$hostname + "grupos/list_grupo_patentes/", {
          id_grupo: this.$local_storage.get("id_grupo")
        })
        .then(response => {
          if (response.data != undefined) {
            this.patentesArr = response.data;
          }
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las patentes.",
            footer: ""
          });
        });
    },
    quitaEspacios(event) {
      this.model.clave_ws = this.model.clave_ws.trim();
    },
    eliminar: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: idreporte,
          }
          axios.post(this.$hostname + 'catalogos/certificados/delete_certificados_agente/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El proceso se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el proceso. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
    openModal: function(type) {
      this.model.rfc_agente = "";
      this.model.patente = "";
      this.model.clave_ws = "";
      this.file_c = "";
      this.file_k = "";
      this.editando = false;
      this.modal = true;
      this.$refs.certificado.removeFile();
      this.$refs.llave.removeFile();
    },
    editar: function(row) {

      this.model.rfc_agente = row.rfc_agente;
      this.model.patente = row.patente;
      this.model.clave_ws = row.clave_ws;
      this.model.password = row.password;
      this.model.curp = row.curp;
      this.file_c = "";
      this.file_k = "";
      this.editando = true;
      this.modal = true;
      this.$refs.certificado.removeFile();
      this.$refs.llave.removeFile();
    },
    limpiarModel: function() {
      for (var k in this.model) {
        this.model[k] = "";
      }
    },
    base64ToArrayBuffer: function(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    open_log: function(patente) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        cliente: this.rfc,
        tipo: 2,
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };
      axios
        .post(
          this.$hostname + "catalogos/certificados/logs/",
          data
        )
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.logs = res.data.filter(s => s.patente == patente);
            this.$root.$dialogLoader.hide();
            this.modal_log = true;
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "descargas.econnectpro.mx"
      }
      let nombre_download = key.split("/").pop();
      axios.post(this.$hostname + "s3/download/", datos, {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Allow: "POST",
          "cache-control": "no-cache",
        })
        .then(response => {
          var bytes = this.base64ToArrayBuffer(response.data);
          let blob = new Blob([bytes], {
              type: response.headers["content-type"]
            }),
            url = window.URL.createObjectURL(blob);

          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = nombre_download;
          a.click();
          a.parentNode.removeChild(a);
        })
        .catch(error => {
          console.log(error);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });

    },
    download: function(nombre, file) {
      var binaryString = window.atob(file);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      const url = window.URL.createObjectURL(
        new Blob([bytes, {
          type: "octet-stream"
        }])
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombre);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        cliente: this.$local_storage.get("rfc_grupo"),
        headers: {
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache"
        }
      };
      axios
        .post(
          this.$hostname + "catalogos/certificados/list_certificados_agentes/",
          data
        )
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.sellos.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    send: function() {
      var url = this.URL;
      var url_token = this.$hostname + "catalogos/certificados/guardar_certificados_agente/";

      let data = {
        file_cer: this.file_c,
        file_key: this.file_k,
        cliente: this.rfc,
        id_usuario: this.usuario,
        clave_ws: this.model.clave_ws,
        password: this.model.password,
        rfc_agente: this.model.rfc_agente,
        patente: this.model.patente,
        curp: this.model.curp,
      };

      let self = this;

      axios
        .post(url_token, data)
        .then(function(response) {
          self.$swal({
            type: "success",
            title: "Operación Existosa",
            text: response.data.mensaje,
            footer: ""
          });
          self.modal = false;
          self.cargar();
        })
        .catch(function(error) {
          var msg =
            "Ocurrió un error al actualizar el certificado, favor de verificar la información";
          console.log(error);
          if (error.response.data.mensaje) {
            self.$swal({
              type: "error",
              title: "Operación No Valida",
              text: error.response.data.mensaje[0],
              footer: ""
            });
          } else {
            self.$swal({
              type: "error",
              title: "Datos no Válidos",
              text: msg,
              footer: ""
            });
          }
        });

    },
  },
  components: {
    FilePond
  }
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
</style>
